import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

interface MyHrLoginTwoFactorRegisterWithSecretCodeProps {
  data: { secret: string };
  setManualSetting: (value: boolean) => void;
}

export const MyHrLoginTwoFactorRegisterWithSecretCode = ({
  data,
  setManualSetting,
}: MyHrLoginTwoFactorRegisterWithSecretCodeProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{ textAlign: "center", marginTop: "24px" }}>
        <Typography variant="h6">{t("MY_HR_CANNOT_SCAN_QR_CODE")}</Typography>
      </Box>
      <Box sx={{ textAlign: "left", marginTop: "36px" }}>
        <Typography variant="body1">
          {t("MY_HR_ENTER_MANUAL_CODE_INTO_AUTH_APP")}
        </Typography>
      </Box>

      <Box
        sx={{
          marginTop: "16px",
          marginBottom: "16px",
          wordBreak: "break-all",
        }}
      >
        <Typography id="code" variant="h6">
          {data.secret}
        </Typography>
      </Box>
      <Box
        sx={{ textAlign: "center", cursor: "pointer" }}
        onClick={() => setManualSetting(false)}
      >
        <Typography id="retryQrCodeScan" color="#CC0033" variant="body1">
          {t("MY_HR_RETRY_QR_CODE_SCAN")}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyHrLoginTwoFactorRegisterWithSecretCode;
